import httpService from './httpService';

interface FeatureCache {
  features: string[];
  timestamp: number;
}

const CACHE_DURATION = 5 * 60 * 1000; // 5 minutes

export class BetaFeatureService {
  private static featureCache = new Map<number, FeatureCache>();

  /**
   * Get all beta features that a community has access to
   */
  static async getFeaturesForCommunity(communityId: number): Promise<string[]> {
    const cached = this.featureCache.get(communityId);
    if (cached && Date.now() - cached.timestamp < CACHE_DURATION) {
      return cached.features;
    }

    try {
      const response = await httpService.get<string[]>(
        `/beta/communities/${communityId}/features`
      );

      const features = response.data;
      this.featureCache.set(communityId, {
        features,
        timestamp: Date.now(),
      });

      return features;
    } catch (error) {
      console.error('Error fetching beta features:', error);
      return [];
    }
  }

  /**
   * Check if a community has access to a specific beta feature
   */
  static async hasAccess(communityId: number, feature: string): Promise<boolean> {
    const features = await this.getFeaturesForCommunity(communityId);
    return features.includes(feature);
  }

  /**
   * Clear the cache for a specific community or all communities
   */
  static clearCache(communityId?: number): void {
    if (communityId !== undefined) {
      this.featureCache.delete(communityId);
    } else {
      this.featureCache.clear();
    }
  }
}
